import { Outlet } from 'react-router-dom';

const OnboardingLayout = () => {
  return <Outlet />;
};

export default OnboardingLayout;
